'use strict';

import request from 'superagent';
import api from './core';
import {cachePromise} from '../utils';

const cache = {
    companiesMap: undefined,
    companies: undefined
};

/**
 * Fetches a list of companies with filter
 *
 * @param q {string} Text search
 * @param page {number} Page to display
 * @returns {Promise}
 */
export function list(q = '', page = 1) {
    const params = { q, page };

    return api.forwardResult(
        api.prepare(request.get(api.url('/companies/')).query(params)),
        'results'
    );
}

export function emptyCompany() {
    return {
        name: '',
        slug: '',
        types: [],
        contacts: []
    };
}

export function emptyType() {
    return {
        name: '',
        slug: '',
        automation_type: 'none'
    };
}

/**
 * List of all available automation types, however the reference value is
 * located in the Python module finance.models. That's just a copy for
 * convenience from the front-end.
 */
export function automationTypes() {
    return [
        {
            label: 'Aucune',
            value: 'none'
        },
        {
            label: 'Generali (Assurance Vie)',
            value: 'generali_vie'
        },
        {
            label: 'Generali PER',
            value: 'generali_per'
        }
    ];
}

/**
 * Checks if the chosen automation type is valid
 *
 * @return {boolean}
 */
export function isAutomationTypeValid(automationType) {
    return automationTypes().some(type => type.value === automationType);
}

function getCompanyPage(page) {
    return new Promise((resolve, reject) => {
        api.prepare(request.get(api.url('/companies/'))).query({page}).end((err, res) => {
            if (err || !res.body || !res.body.results) {
                reject('Impossible d\'obtenir la liste des compagnies');
            }

            resolve(res.body);
        });
    });
}

export async function fetchAllCompanies() {
    let next = 1;
    const out = [];

    while (next) {
        const page = await getCompanyPage(next);

        if (page.next) {
            next += 1;
        } else {
            next = false;
        }

        out.push(...page.results);
    }

    return out;
}

export const getAllCompanies = cachePromise(fetchAllCompanies, cache, 'companies');

export async function makeAllCompaniesMap() {
    const companies = await getAllCompanies();
    const out = {};

    companies.forEach((company) => {
        const types = {};

        company.types.forEach((type) => {
            types[type.slug] = {
                name: type.name,
                slug: type.slug
            };
        });

        out[company.slug] = {
            name: company.name,
            types
        };
    });

    return out;
}

export const getAllCompaniesMap = cachePromise(makeAllCompaniesMap, cache, 'companiesMap');

export function update(company) {
    const id = encodeURIComponent(company.id);
    return api.forwardResult(
        api.prepare(request.put(api.url(`/companies/${id}/`))).send(company),
        'id'
    );
}

export function create(company) {
    return api.forwardResult(
        api.prepare(request.post(api.url('/companies/'))).send(company),
        'id'
    );
}

export function fetch(id) {
    return api.forwardResult(api.prepare(request.get(api.url(`/companies/${id}/`))), 'id');
}



// WEBPACK FOOTER //
// ./src/api/companies.js